import React, { useEffect, useState } from 'react';

import { ErrorMessageWrapper } from '~/components/error-message-wrapper/ErrorMessageWrapper';
import { useInsights } from '~/stores/use-insights/useInsights';
import { useWatchlist } from '~/stores/use-watchlist/useWatchlist';
import { Watchlist } from '~/stores/use-watchlist/watchlist-types';
import {
  DEFAULT_TAB,
  useWatchlistTable,
} from '~/views/watchlist-page/hooks/useWatchlistTable';

import { AssetsHeader } from './assets-header/AssetsHeader';
import { AssetsTable } from './assets-table/AssetsTable';
import { EmptyState } from './empty-state/EmptyState';
import * as S from './MyAssetsWidget.styles';
import { WatchlistSummary } from './watchlist-summary/WatchlistSummary';

export interface MyAssetsWidgetProps {
  lists: Watchlist[];
}

export const MyAssetsWidget = ({ lists }: MyAssetsWidgetProps) => {
  const [isSummaryOpen, setIsSummaryOpen] = useState(false);
  const { activeListId, getLists, error } = useWatchlist();
  const { getInsights } = useInsights();

  const fallback = lists[0];
  const currentList = activeListId
    ? lists.find(l => l.id === activeListId) ?? fallback
    : fallback;
  const entities = currentList?.entities ?? [];
  const { watchlistTableData, columnsMeta } = useWatchlistTable({ entities });

  const tags = watchlistTableData.map(d => d.tag);

  useEffect(() => {
    if (tags.length) {
      getInsights({
        entity: tags,
        limit: 1000,
      });
    }
  }, [tags.toString()]);

  if (!error && !currentList) {
    return <EmptyState />;
  }

  const getWidgetContent = () => {
    if (error) {
      return (
        <ErrorMessageWrapper
          displayIcon
          onClick={getLists}
          showBorder={false}
        />
      );
    }

    if (isSummaryOpen && currentList) {
      return <WatchlistSummary watchlistId={currentList.id} />;
    }

    return (
      <AssetsTable
        columnsMeta={columnsMeta}
        tab={DEFAULT_TAB}
        data={watchlistTableData}
        listId={currentList.id}
      />
    );
  };

  return (
    <S.MyAssetsWidgetRoot>
      <AssetsHeader
        setIsSummaryOpen={setIsSummaryOpen}
        isSummaryOpen={isSummaryOpen}
        list={currentList}
      />
      {getWidgetContent()}
    </S.MyAssetsWidgetRoot>
  );
};
